module.exports = __webpack_public_path__ + "img/OutlanderSport-22.a6e8abce.jpg";